import { schema } from 'normalizr';
import { SchemaKeys } from 'data/core';
import { dataNormalizer } from 'data/core/utils';
import { projectSchema } from 'data/projects/schema';
import { taskSchema } from 'data/tasks/schema';
export const spaceSchema = new schema.Entity(SchemaKeys.Spaces, {}, {
    idAttribute: (value)=>String(value.spaceId),
    processStrategy: (entity)=>{
        return entity.spaceTabs ? {
            ...entity
        } : {
            ...entity,
            spaceTabs: []
        };
    }
});
export const spaceTabSchema = new schema.Entity(SchemaKeys.SpaceTabs, {}, {
    idAttribute: (value)=>String(value.spaceTabId),
    processStrategy: (entity)=>entity.taskList ? {
            ...entity
        } : {
            ...entity,
            taskList: []
        }
});
spaceTabSchema.define({
    space: spaceSchema,
    taskList: [
        taskSchema
    ]
});
spaceSchema.define({
    spaceTabs: [
        spaceTabSchema
    ],
    project: projectSchema
});
export const spaceNormalizer = (data)=>dataNormalizer(data, spaceSchema);
